import { render, staticRenderFns } from "./ReferralProgram.vue?vue&type=template&id=86fc1572&"
import script from "./ReferralProgram.vue?vue&type=script&lang=ts&"
export * from "./ReferralProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports